import {useState} from "react";
import { createContext, useEffect, useReducer, useContext } from "react";
import { LiferayService } from "../../../common/services/liferay/index";
import { ApplicationPropertiesContext } from "../../../common/context/ApplicationPropertiesProvider";
import { decode_utf8, getPathName } from "../../../common/utils/utilsFunc";

export const FormVoluntaryCollectiveProcedureContext = createContext();
export const ACTIONS = {
  SET_SERV1: "SET_SERV1",
  SET_RESPONSE_SERV1: "SET_RESPONSE_SERV1",
  SET_DETAIL_CLIENT: "SET_DETAIL_CLIENT",
  SET_WEB_CONTENT_TEXT_INFO: "SET_WEB_CONTENT_TEXT_INFO",

};
const initialState = {
  serv1: null,
  response_serv1: null,
  detailClient: null,
  webContentTextInfo: "",
};
const FormVoluntaryCollectiveProcedureReducer = (state = initialState, action) => {
  switch (action.type) {
    case ACTIONS.SET_DETAIL_CLIENT: {
      return {
        ...state,
        detailClient: action.payload
      };
    }
    case ACTIONS.SET_SERV1: {
      return {
        ...state,
        serv1: action.payload,
      };
    }
    case ACTIONS.SET_RESPONSE_SERV1: {
      return {
        ...state,
        response_serv1: action.payload,
      };
    }
    case ACTIONS.SET_WEB_CONTENT_TEXT_INFO: {
      return {
        ...state,
        webContentTextInfo: action.payload,
      };
    }
    default: {
      return state;
    }
  }
};
const FormVoluntaryCollectiveProcedureContextProvider = ({ children }) => {
  const properties = useContext(ApplicationPropertiesContext);

  const [state, dispatch] = useReducer(FormVoluntaryCollectiveProcedureReducer, initialState);
    
    useEffect(() => {
      if (getPathName() === 'procedimiento-voluntario-colectivo') {
        if(state.serv1){
          LiferayService.consultarDetalleCuentaContrato(properties.base_url_api, state.serv1, properties.url_ws_empresa, properties.codigo_empresa)
          .then((response) => {
            dispatch({
              payload: response,
              type: ACTIONS.SET_DETAIL_CLIENT,
            });
          })
          
          LiferayService.consultPvc(properties.base_url_api,state.serv1,properties.codigo_empresa)
          .then((response) => {
            dispatch({
              payload: response,
              type: ACTIONS.SET_RESPONSE_SERV1,
            });
            dispatch({
                payload: null,
                type: ACTIONS.SET_SERV1,
            });
          })
        }
      }
    }, [state.serv1]);

    useEffect(() => {
      if (decode_utf8(properties.web_content_info_update_of_contact_information).trim()) {
        LiferayService.getWebContent(properties.base_url_api, decode_utf8(properties.web_content_info_update_of_contact_information).trim())
        .then((response) => {
          dispatch({
            payload: response,
            type: ACTIONS.SET_WEB_CONTENT_TEXT_INFO,
          });
        })
      }
    },[])
  
  return (
    <FormVoluntaryCollectiveProcedureContext.Provider value={[state, dispatch]}>
      {children}
    </FormVoluntaryCollectiveProcedureContext.Provider>
  );
};

export default FormVoluntaryCollectiveProcedureContextProvider;